export const SEARCH_URL = "https://ydkw9dy53a.execute-api.ap-northeast-1.amazonaws.com/api";
export const REPLY_URL = "https://4v7sjgy4r6.execute-api.ap-northeast-1.amazonaws.com/api";
